import {BASE_PX} from '../constants';

export function remToPx(rem: number) {
  return rem * BASE_PX;
}